import { makeUsersData } from './users-data';

// Shared in-memory state
export const sharedState = makeUsersData();

// Helper to get next user ID
export let nextUserId =
  Math.max(...sharedState.users.map((u) => parseInt(u.id))) + 1;

// Helper to get next role ID
export let nextRoleId =
  Math.max(...sharedState.roles.map((r) => parseInt(r.id))) + 1;

// Helper functions to update IDs
export function getNextUserId(): string {
  return (nextUserId++).toString();
}

export function getNextRoleId(): string {
  return (nextRoleId++).toString();
}

// Helper function to update role user counts
export function updateRoleUserCounts(): void {
  sharedState.roles.forEach((role) => {
    role.userCount = sharedState.users.filter(
      (user) => user.role.id === role.id,
    ).length;
  });
}
